module.exports = __webpack_public_path__ + "img/IMG_0874.cc133d69.jpeg";